<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="3xl" [customTitle]="(isEdit ? 'Editar' : 'Conectar') + ' tienda WooCommerce'"
    (closeFunction)="closeFormFunction()" (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <section class="space-y-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">Conexión</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <custom-input [autofocus]="true" label="Nombre" type="text" placeholder="Tienda online"
                    [formControlItem]="saveForm.get('name')"></custom-input>

                <custom-input label="URL de la tienda" type="text" placeholder="https://mitienda.com"
                    [formControlItem]="saveForm.get('store_url')"
                    [errorMessages]="{ pattern: 'Debe empezar por https://' }"></custom-input>

                <custom-input label="Consumer key" type="password" placeholder="ck_..."
                    [formControlItem]="saveForm.get('consumer_key')"></custom-input>

                <custom-input label="Consumer secret" type="password" placeholder="cs_..."
                    [formControlItem]="saveForm.get('consumer_secret')"></custom-input>
            </div>

            <p class="text-xs text-neutral-500">
                En WordPress: WooCommerce → Ajustes → Avanzado → API REST → Añadir clave, con permisos de
                <strong>Lectura/Escritura</strong>.
                @if(isEdit){ Deja las claves vacías para mantener las actuales. }
            </p>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="enabled"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                <span class="text-sm font-medium text-neutral-700">Integración activa</span>
            </label>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="query_string_auth"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-neutral-700">Enviar claves en la URL</span>
                    <span class="text-xs text-neutral-500">Solo si la tienda rechaza las claves y su hosting elimina la cabecera Authorization</span>
                </div>
            </label>
        </section>

        <section class="space-y-4 pt-4 border-t border-neutral-200">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">Catálogo</h2>

            <custom-select label="Precio que se publica" [formControlItem]="saveForm.controls['price_field']"
                [options]="dropdowns.price_fields" bindValue="id" bindLabel="name" placeholder="Selecciona un precio">
            </custom-select>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="erp_prices_include_tax"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                <span class="text-sm font-medium text-neutral-700">Los precios del ERP incluyen IVA</span>
            </label>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="sync_categories"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                <span class="text-sm font-medium text-neutral-700">Sincronizar categorías</span>
            </label>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="sync_stock"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                <span class="text-sm font-medium text-neutral-700">Sincronizar stock</span>
            </label>

            @if(taxMapRows.length){
            <div formArrayName="tax_map_rows" class="space-y-2">
                <p class="text-sm font-medium text-neutral-700">Clases de impuesto en WooCommerce</p>
                <p class="text-xs text-neutral-500">Slug de la clase de impuesto de la tienda (p. ej. <code>reduced-rate</code>). Vacío = tasa estándar.</p>
                @for(row of taxMapRows.controls; track $index){
                <div [formGroupName]="$index" class="grid grid-cols-2 gap-4 items-center">
                    <span class="text-sm text-neutral-700">{{ row.value.label }}</span>
                    <custom-input type="text" placeholder="standard" [formControlItem]="row.get('tax_class')"></custom-input>
                </div>
                }
            </div>
            }
        </section>

        <section class="space-y-4 pt-4 border-t border-neutral-200">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">Pedidos web</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <custom-select label="Crear cada pedido como" [formControlItem]="saveForm.controls['order_document_type']"
                    [options]="documentTypes" bindValue="id" bindLabel="name" placeholder="Selecciona un tipo">
                </custom-select>

                <custom-select label="Estados que se importan" [formControlItem]="saveForm.controls['import_statuses']"
                    [options]="orderStatuses" bindValue="id" bindLabel="name" [isMultiple]="true"
                    placeholder="Selecciona estados">
                </custom-select>

                <custom-select label="Oficina" [formControlItem]="saveForm.controls['office_id']"
                    [options]="dropdowns.offices" bindValue="id" bindLabel="name" placeholder="Selecciona una oficina">
                </custom-select>

                <custom-select label="Cliente para pedidos web" [formControlItem]="saveForm.controls['default_client_id']"
                    [options]="dropdowns.clients" bindValue="id" bindLabel="name" bindSubLabel="nif"
                    placeholder="Selecciona un cliente">
                </custom-select>

                <custom-select label="Producto de portes" [formControlItem]="saveForm.controls['shipping_product_id']"
                    [options]="dropdowns.products" bindValue="id" bindLabel="label" placeholder="Selecciona un producto">
                </custom-select>

                <custom-select label="Forma de pago por defecto" [formControlItem]="saveForm.controls['default_pay_id']"
                    [options]="dropdowns.pay_methods" bindValue="id" bindLabel="name" placeholder="Selecciona una forma de pago">
                </custom-select>
            </div>

            <div formArrayName="pay_method_rows" class="space-y-2">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-sm font-medium text-neutral-700">Formas de pago de la tienda</p>
                        <p class="text-xs text-neutral-500">Código de la pasarela en WooCommerce (<code>bacs</code>, <code>cod</code>, <code>stripe</code>...) → forma de pago del ERP</p>
                    </div>
                    <button type="button" (click)="addPayMethodRow()"
                        class="px-3 py-1.5 bg-white border border-indigo-200 text-indigo-700 text-xs font-semibold rounded-lg hover:bg-indigo-50 transition-colors">
                        Añadir
                    </button>
                </div>
                @for(row of payMethodRows.controls; track $index){
                <div [formGroupName]="$index" class="grid grid-cols-[1fr_1fr_auto] gap-4 items-start">
                    <custom-input type="text" placeholder="bacs" [formControlItem]="row.get('gateway')"></custom-input>
                    <custom-select [formControlItem]="$any(row).controls['pay_id']" [options]="dropdowns.pay_methods"
                        bindValue="id" bindLabel="name" placeholder="Forma de pago"></custom-select>
                    <button type="button" (click)="removePayMethodRow($index)"
                        class="mt-1 px-3 py-2 text-xs font-semibold text-red-600 rounded-lg hover:bg-red-50 transition-colors">
                        Quitar
                    </button>
                </div>
                }
            </div>
        </section>

    </form>
</app-custom-modal>
}
